module.exports = __webpack_public_path__ + "static/media/footer.85bbbfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/scenes/Images/footer.png
// module id = 760
// module chunks = 0